import { denormalize } from "normalizr";
import schemas from "utils/schemas";

export const getFinancedOffers = state => {
  const projection = state.document.contractGeneration;
  if (projection && projection.isLoaded) {
    const contractGeneration = denormalize(projection.offerids, [schemas.contractGeneration], state.entities);
    return contractGeneration;
  }
  return [];
};
